import React from 'react';
import { Select } from '../CommonComponents/OPL/Select/Select/Select';

export default ({
  onPlanChanged,
  clientId,
  capsuleId,
  plans,
  selectedPlan,
  optionMapper,
  isDropdownEnabled,
  className,
}) =>
  isDropdownEnabled && (
    <div className={`right-box ${className || ''}`}>
      <div className="plan-selection-dropdown">
        {plans.length <= 0 && <span className="plan-selection-static">{selectedPlan.name}</span>}

        {plans.length > 0 && (
          <Select
            value={optionMapper(selectedPlan)}
            options={plans.map(optionMapper)}
            onChange={onPlanChanged(clientId, capsuleId)}
          />
        )}
      </div>
    </div>
  );
